import React from 'react';
import GenericModulePage from '../../components/generic/GenericModulePage';
import { initializeModule } from '../../utils/configInit';
import { productStatusChangeConfig } from './productStatusChangeConfig';
import { createProductStatusChangeValidationSchema } from './productStatusChangeValidation';
import CustomProductStatusChangeSplitView from './CustomProductStatusChangeSplitView';

/**
 * Initialize the Product Status Change module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  productStatusChangeConfig,
  createProductStatusChangeValidationSchema
);

// Set the custom split view component
initializedConfig.customSplitViewPanel.component = CustomProductStatusChangeSplitView;

/**
 * Product Status Change Page component
 * Uses the same style as ComplaintPage - directly using GenericModulePage
 */
const ProductStatusChangePage = () => {
  return (
    <GenericModulePage 
      config={initializedConfig}
    />
  );
};

export default ProductStatusChangePage;

